import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-light-svg-icons';

import { Widget } from '../../../../../../components/v2/widget';
import { AccountEquityCard } from '../../../../../portfolio-performance/components/cards/account-equity-card';
import { IPortfolioPerformanceAccountReport } from '../../../../../../providers/portfolio-performance/portfolio-performance.types';
import { RangeListEnum } from '../../../../../portfolio-performance/types';

interface BacktestEquityChartProps {
  report: IPortfolioPerformanceAccountReport | null;
  strategyName: string;
}

// Renders the real Portfolio Performance equity/underwater/HWM card for the
// stratlet currently open in the Overview table (that table is the single
// source of truth for selection — no widget-local dropdown).
export const BacktestEquityChart = ({ report, strategyName }: BacktestEquityChartProps) => (
  <Widget cardKey="backtest-equity-chart">
    <Widget.Header>
      <Widget.Title title={strategyName ? `Equity — ${strategyName}` : 'Equity'} />
      <Widget.Buttons>
        <Widget.Button icon={faArrowUpRightAndArrowDownLeftFromCenter} onClick={() => {}} />
      </Widget.Buttons>
    </Widget.Header>
    <Widget.Content>
      <AccountEquityCard
        data={report?.historical}
        denomination={report?.denomination}
        defaultRange={RangeListEnum.ALL}
      />
    </Widget.Content>
    <Widget.Footer />
  </Widget>
);
